import { getImageObject, getLayerRecolorEnabled } from '../utils';

export function ImageArrayLayerHandler(
  resAst: Ast,
  layerAst: Ast,
  layer: StoreLayerItem,
  colors: StoreThemeColorItem[]
) {
  layer.attrs.resources = {
    images: getImageObject(resAst, layerAst.attrsMap.name, colors)
  };
  layer.attrs.recolorEnable = getLayerRecolorEnabled(
    resAst,
    layerAst.attrsMap.name
  );
  layer.attrs = { ...layerAst.attrsMap, ...layer.attrs };
}
